import { fsfn_api } from "global/functions/fbApi";
import { fsfn_allAuth } from "global/functions/fbAuth";
import { fsfn_create } from "global/functions/fbCreate";
import { fsfn_allFetch } from "global/functions/fbFetchFunctions";
import { fsfn_notifications } from "global/functions/fbNotifications";
import { fsfn_allReg } from "global/functions/fbRegFunctions";
import { fsfn_allSettings } from "global/functions/fbSettingsFunctions";
import { fsfn_sheets } from "global/functions/fbSheetsFuntions";
import { fsfn_storage } from "global/functions/fbStorageFunctions";
import { fsfn_transfer } from "global/functions/fbTransfer";
import _ from 'lodash';
import { useContext, useMemo } from "react";
import { AppContext } from "../AppProvider";
import { fsCallAll } from "../contextHelpers/fcCalls";
import { DatabaseContext } from "../DatabaseContext";
import { fsfn_delete } from "global/functions/fbDelete";

const _showCallLogs = true;

export const useFunctions = () => {
  // ---- parent contexts ----
  const { database_fns } = useContext(DatabaseContext) ?? {};
  const { app_state } = useContext(AppContext);

  const { mainFunctions, app_alts, app_prods, mainStorage } = app_state ?? {};
  const { altFunctions } = app_alts ?? {};
  const { prodFunctions } = app_prods ?? {};

  // ---- combine functions ----
  const allFunctions = useMemo(
    () => ({ mainFunctions, altFunctions, prodFunctions }),
    [mainFunctions, altFunctions, prodFunctions]
  );

  // ---- unified fsCall ----
  const fsCall = async (genericType, callData) => {
    return fsCallAll(mainFunctions, genericType, callData, allFunctions, _showCallLogs);
  };

  // ---- build all function groups ----
  const functions_fns = useMemo(() => ({
    fc_api: fsfn_api(fsCall),
    fc_auth: fsfn_allAuth(fsCall),
    fc_create: fsfn_create(fsCall, database_fns),
    fc_delete: fsfn_delete(fsCall, database_fns),
    fc_fetch: fsfn_allFetch(fsCall),
    fc_notifications: fsfn_notifications(fsCall, database_fns),
    fc_reg: fsfn_allReg(fsCall),
    fc_settings: fsfn_allSettings(fsCall),
    fc_sheets: fsfn_sheets(fsCall, database_fns),
    fc_storage: fsfn_storage(fsCall, mainStorage),
    fc_transfer: fsfn_transfer(fsCall),
  }), [fsCall, database_fns, mainStorage]);

  // ---- flatten all functions into one merged object ----
  const fn_cls = useMemo(() => {
    const merged = {};
    _.forEach(functions_fns, (fnp) => {
      _.forEach(fnp, (fnpi, fnpik) => {
        if (merged[fnpik]) {
          console.warn("⚠️ Duplicate function name:", fnpik);
        } else {
          merged[fnpik] = fnpi;
        }
      });
    });
    return merged;
  }, [functions_fns]);

  return { fn_cls };
};
